export default {
  title: 'Gira o seu negócio em qualquer lugar',
  description: 'Inicie sessão na sua conta.',
  form: {
    email: {
      label: 'E-mail',
      placeholder: 'Introduza o e-mail',
    },
    password: {
      label: 'Palavra-passe',
      placeholder: 'Introduza a palavra-passe',
    },
    error_messages: {
      missing_info: 'Informação em falta',
      wrong_credentials: 'E-mail ou palavra-passe incorretos',
    },
  },
  buttons: {
    login: 'Iniciar sessão',
    forgot_password: 'Esqueceu a palavra-passe',
  },
  white_label: {
    title: 'Inicie sessão no seu painel de controlo',
    form: {
      email: {
        label: 'Endereço de e-mail',
        placeholder: 'voce@restaurante.com',
      },
      password: {
        label: 'Palavra-passe',
        placeholder: 'Introduza a sua palavra-passe',
      },
    },
    buttons: {
      login: 'Iniciar sessão',
    },
    intro: {
      eyebrow: 'Gestão de pedidos',
      headline: 'Gira o seu restaurante em qualquer lugar.',
      description: 'Pedidos, menus, horários e pagamentos — tudo num só lugar.',
      features: {
        live: {
          title: 'Em direto',
          subtitle: 'rastreio de pedidos',
        },
        instant: {
          title: 'Instantâneo',
          subtitle: 'alterações ao menu',
        },
        any_device: {
          title: 'Qualquer dispositivo',
          subtitle: 'telemóvel ou tablet',
        },
      },
    },
  },
};
